import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { ProloenSetupRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { Box, Grid } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import {
    SecondaryButtonStyle,
    PrimaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';
interface ProlonConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const ProlonConnect = (props: ProlonConnectProps) => {
    const { t } = useTranslation();
    const [credentials, setCredentails] = useState<ProloenSetupRequest>(
        {} as any
    );
    const { setAlert } = useNotificationsSnackbar();

    const { proloenSetup } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        proloenSetup.mutate(credentials);
    };

    useEffect(() => {
        if (proloenSetup.isSuccess) {
            props.onSaveSuccess?.();
        }
    }, [proloenSetup.isSuccess]);

    useEffect(() => {
        dispatch(setLoader(proloenSetup.isPending));
    }, [proloenSetup.isPending]);

    useEffect(() => {
        if (proloenSetup.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [proloenSetup.isError]);

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={credentials?.username ?? ''}
                    label={'Username'}
                    onChange={(e) => {
                        setCredentails({
                            ...credentials,
                            username: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    type="password"
                    value={credentials?.password ?? ''}
                    label={'Password'}
                    onChange={(e) => {
                        setCredentails({
                            ...credentials,
                            password: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props?.onClose}
                    sx={{ width: '170px' }}
                >
                    {t('cancel')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle onClick={onClick} sx={{ width: '170px' }}>
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
